import {toFixedVector} from "../../../../utils/utils";

export class Node {
    constructor(point, elements, identifier) {
        this.point = toFixedVector(point);
        this.identifier = identifier;
        this.connectedBuildingElements = elements;
        this.connectedNodes = [];
    }
}
